import React, { useState, useEffect } from 'react';
import { Container} from '@mui/material';
// import OrderDataGrid from './orderDataGrid'
import OrderList from './orderList'
import Copyright from '../Copyright';
import { useUserContext} from "../lib/user_context";


export default function OrderStatus(props) {
    const { sessionAccount} = useUserContext();
     useEffect(() => {
         console.log("OrderStatus sessionAccount is " + sessionAccount);

        const style = document.createElement('style');
        style.id = 'tidio-order-status-style';
        style.innerHTML = `
            #tidio-chat-iframe {
                left: 50% !important;
                transform: translateX(-50%) !important;
                right: auto !important;
            }
        `;
        document.head.appendChild(style);

        return () => {
            const styleElement = document.getElementById('tidio-order-status-style');
            if (styleElement) {
                document.head.removeChild(styleElement);
            }
        };
     }, [sessionAccount]);

    return (
        <Container maxWidth="false" className="NewOrder" style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - var(--header-height, 64px))' }}>
            <div style={{ flex: 1, minHeight: 0 }}>
                <OrderList account={sessionAccount}/>
            </div>
            {props.isEmbedded!==null && props.isEmbedded!=="yes" && (
                <footer>
                    <Copyright/>
                </footer>
            )}
        </Container>
    );
}